/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-empty */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { LOGGED_IN_USER_URL } from '../../../../../services/api/auth/AuthUrl';
import { DATA_ANALYSIS, SUPER_ADMIN } from '../../../../../utils/departments/helpers';
import profile from '../../../../../assets/img/icons/Profile.png';
import ViewUserProfile from '../../../shared/staff/ViewUserProfile';
import DataAnalysisNavBar from '../../../../layouts/data-analysis/DataAnalysisNavBar';
import BulkExtension from '../../../shared/account-extension/BulkExtension';

const DataAnalysisExtension = () => {
  useEffect(() => {
    checkDepartment();

  }, []);

  const checkDepartment = async () => {
    try {
      const response = await axios.get(`${LOGGED_IN_USER_URL}`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      });

      if (![DATA_ANALYSIS, SUPER_ADMIN].includes(response.data.department_id)) {
        sessionStorage.clear();
        toast.info('You are not allowed to view this page');
        window.location.href = '/';
      }
    } catch (e) {}
  };

  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <div className="d-flex col-lg-12 p-2 top-header">
          <DataAnalysisNavBar currentPage="Bulk Extension" profileImage={profile} position />
        </div>

        <div className="col-12 after-summary">
          <ViewUserProfile />
        <BulkExtension />

        
        </div>
      </main>
      <ToastContainer />
    </div>
  );
};


export default DataAnalysisExtension;
